module.exports = new __parcel__URL__("bk55_icon.717f41b1.png").toString();